import { useEffect, useState } from 'react';
import { RouteMetadata } from '@/components/seo/RouteMetadata';

export const PrivacyPolicyRoute = () => {
  const [htmlContent, setHtmlContent] = useState<string>('');

  useEffect(() => {
    // Fetch the privacy policy HTML file
    fetch('/privacy-policy.html')
      .then(response => response.text())
      .then(html => setHtmlContent(html))
      .catch(error => {
        console.error('Error loading privacy policy:', error);
        setHtmlContent('<div class="p-8"><h1>Privacy Policy</h1><p>Error loading privacy policy content.</p></div>');
      });
  }, []);

  return (
    <>
      <RouteMetadata
        title="Privacy Policy - Uavity"
        description="Read our privacy policy to understand how we collect, use, and protect your data."
        keywords="privacy policy, data protection, user privacy, data collection, privacy rights"
        tags={['privacy', 'legal', 'data protection', 'user rights']}
      />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div 
            className="prose prose-slate dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </div>
      </div>
    </>
  );
};
